module.exports = __webpack_public_path__ + "static/391bb3489c5699592488b281bb0e82cc00a4538ef9befe0e71e8fab06603c6eb-317c0520e3972c9174c61ee444797bfd.png";